var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.76599C0 2.55351 2.55351 0 5.76599 0C8.97847 0 11.532 2.55351 11.4496 5.76599C11.4496 7.33105 10.873 8.81373 9.71981 9.88456C9.71981 9.94615 7.83121 11.62 6.84418 12.4947C6.51132 12.7898 6.28099 12.9939 6.26022 13.0147C6.0131 13.2618 5.51888 13.2618 5.18939 13.0147C5.14821 12.9735 4.3039 12.2115 3.45959 11.4496C2.61529 10.6877 1.77098 9.92574 1.7298 9.88456C0.576599 8.81373 0 7.33105 0 5.76599ZM4.11719 5.76461C4.11719 6.6707 4.85853 7.41204 5.76461 7.41204C6.6707 7.41204 7.41204 6.6707 7.41204 5.76461C7.41204 4.85853 6.6707 4.11719 5.76461 4.11719C4.85853 4.11719 4.11719 4.85853 4.11719 5.76461Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.53c45adee7b64b11a2bb3be63b021081.svg";
export { ForwardRef as ReactComponent };